module.exports = __webpack_public_path__ + "static/img/banner01.999046b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner01.jpg
// module id = DJe/
// module chunks = 1